import BaseBookmarks from "./base-bookmarks";

class LotBookmark extends BaseBookmarks {

    constructor() {
        super();
        this.key = 'ao-lt-bo'; //asteonline auction bookarks
    }
}

const lotBookmark = new LotBookmark();
export default lotBookmark;